import type { ReactNode } from "react";
import { PostToTikTokVideoPreview } from "./PostToTikTokVideoPreview";

export interface PostToTikTokEditorLayoutProps {
  videoUrl?: string;
  posterUrl?: string;
  videoLoading?: boolean;
  /** 发布轮询等状态不展示左侧预览 */
  showVideoPreview?: boolean;
  children: ReactNode;
}

export const PostToTikTokEditorLayout = ({
  videoUrl,
  posterUrl,
  videoLoading,
  showVideoPreview = true,
  children,
}: PostToTikTokEditorLayoutProps) => {
  return (
    <div className="flex min-h-0 flex-1">
      {showVideoPreview ? (
        <PostToTikTokVideoPreview videoUrl={videoUrl} posterUrl={posterUrl} loading={videoLoading} />
      ) : null}
      <div className={showVideoPreview ? "flex w-[720px] min-w-0 shrink-0 flex-col" : "flex min-w-0 flex-1 flex-col"}>
        {children}
      </div>
    </div>
  );
};
